/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ab_Bullet1Inputs */

const es_ab_bullet1 = /** @type {(inputs: Ab_Bullet1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingresos extra cuando no lo usas`)
};

const gl_ab_bullet1 = /** @type {(inputs: Ab_Bullet1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingresos extra cando non o usas`)
};

const en_ab_bullet1 = /** @type {(inputs: Ab_Bullet1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extra income when you are not using it`)
};

/**
* | output |
* | --- |
* | "Extra income when you are not using it" |
*
* @param {Ab_Bullet1Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const ab_bullet1 = /** @type {((inputs?: Ab_Bullet1Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ab_Bullet1Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_ab_bullet1(inputs)
	if (locale === "en") return en_ab_bullet1(inputs)
	return es_ab_bullet1(inputs)
});